import CandidatePreference from "./Preferences/CandidatePreference";
import AddressDetails from "./address/AddressDetails";
import Declaration from "./Declaration";
import PaymentPage from "../Payment/PaymentPage";
import Category from "./Categories/Category";
import UploadedDocuments from "./UploadedDocuments";

export const MilestoneMapping = {
  "Declaration Upload": Declaration,
  "Uploaded Documents": UploadedDocuments,
  "Preferences": CandidatePreference,
  "Categories" : Category,
  "Address Details": AddressDetails,
  "Payment": PaymentPage,
};

export const AcordianMapping = [] //["Category"]
export const GroupMapping = [] //["Personal Details", "Photo & Sign","Declaration", "Category Details","Qualifications"]